export const url = 'https://beatthebook.app'
// Prod 'https://beatthebook.app'
// Test 'http://127.0.0.1:5000'